<div class="verification-modal-container">
  <div *ngIf="isCampaignStatusWaiting; else joinCampaign">
    <app-join-program-alert [containerText]="{withTranslation: true, text: 'application_waiting_for_acceptance'}"> </app-join-program-alert>
  </div>
  <ng-template #joinCampaign>
    <ng-container *ngIf="!noTrafficSources; else noTrafficSourcesAlert">
      <div class="verification-note-container">
        <p>{{ 'view_translations.verification_note' | translate }}</p>
      </div>
      <a class="link-to-video" href="https://youtu.be/ye5QHSmjKN0?si=Y2g1vilcCdVuqing" target="_blank">
        <div class="show-video-container">
          <p>{{ 'view_translations.link_joining_the_offer' | translate }}</p>
          <nb-icon pack="icomoon" icon="external-link-bold"></nb-icon>
        </div>
      </a>
      <div class="traffic-source-container">
        <ng-container *ngIf="!loading">
          <app-traffic-source
            [domains]="domains"
            [submitted]="submitted"
            (emitSelectedDomain)="getSelectedDomain($event)"
            (emitAddNewTrafficSource)="openTrafficSourceModal()"></app-traffic-source>
        </ng-container>
        <app-loader *ngIf="loading"></app-loader>
      </div>
      <div class="program-conditions-container">
        <app-program-conditions
          [restrictions]="$any(currentCampaign).restriction"
          [campaignID]="couponModal ? $any(currentCampaign).program_id : currentCampaign?.id"></app-program-conditions>
      </div>
      <div class="program-promotion-description">
        <ng-container *ngIf="additionalRequirements">
          <app-textarea-input
            (emitValue)="getPromotionDescription($event)"
            [fieldInfo]="field"
            [inputName]="'promotion_method_description'"
            [placeholder]="'input_label'"
            [submitted]="submitted"
            [minLengthValue]="100"
            [requiredValue]="true">
          </app-textarea-input>
          <ng-container *ngIf="specialTreatment">
            <app-text-input
              (emitValue)="getOptionalEarningsScreenshot($event)"
              [fieldInfo]="field2"
              [inputName]="'optional_earnings_screenshot'"
              [submitted]="submitted"
              [tooltipText]="'optional_earnings_screenshot_placeholder' | t"
              [requiredValue]="false">
            </app-text-input>
          </ng-container>
        </ng-container>

        <div class="checkbox-container">
          <app-global-checkbox
            [submitted]="submitted"
            [required]="true"
            [text]="'terms_accepted_text'"
            [checked]="termsAccepted"
            (emitChange)="termsAccepted = $event"
            [disabled]="false">
          </app-global-checkbox>
        </div>
      </div>
      <div class="btn-container">
        <app-primary-button
          [buttonText]="'send_verification_button_label'"
          [icon]="'user-plus'"
          [iconSize]="22"
          [background]="'orange'"
          (emitAction)="verify()">
        </app-primary-button>
      </div>
    </ng-container>
  </ng-template>
</div>

<ng-template #noTrafficSourcesAlert>
  <app-join-program-alert
    class="add-traffic-source"
    [buttonText]="'add_traffic_source'"
    [containerTextTitle]="{withTranslation: true, text: 'no_traffic_sources'}"
    [containerTextDesc]="{withTranslation: true, text: 'no_traffic_sources_desc'}"
    (openModal)="openTrafficSourceModal()">
  </app-join-program-alert>
</ng-template>
